import React from 'react';
import BottomExpandableDrawer from '../BottomExpandableDrawer';

import {BUTTON_TYPES} from '../../../utils/Constants';
import {Platform} from 'react-native';
import {useTheme} from '../../../theme';
import styles from './styles';
import {RequestFailedIcon} from '../../../utils/SvgIcons';

const defaultMessage = 'Your submission failed to send. Please try again.';

const ErrorModal = ({
  visible,
  message = defaultMessage,
  onClose,
  testID,
  title = 'Request Failed',
  buttonTitle = 'Close',
}) => {
  const {colors} = useTheme();
  return (
    <BottomExpandableDrawer
      testID={testID}
      title={title}
      rippleColor={colors.dangerMuted}
      visible={visible}
      showRipple={visible}
      subtitle={message}
      rippleIcon={<RequestFailedIcon />}
      textAlign={Platform.OS === 'web' ? 'center' : 'left'}
      buttons={[
        {
          title: buttonTitle,
          buttonType: BUTTON_TYPES.Bordered,
          onPress: onClose,
        },
      ]}
      modalViewStyle={Platform.OS === 'web' && styles.maxWidth327}
    />
  );
};

export default ErrorModal;
